"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _types = require("../../../types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OptionList(_ref) {
  var name = _ref.name,
      options = _ref.options,
      clicked = _ref.clicked,
      selected = _ref.selected;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _utils.transformOptions)(options).map(function (_ref2, index) {
    var label = _ref2.label,
        value = _ref2.value;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "".concat(name, "-").concat(index),
      className: (0, _utils.getClassNames)('select__option', {
        'select__option-active': selected === value
      }),
      "aria-selected": selected === value,
      role: "option",
      tabIndex: 0,
      key: (0, _utils.createUniqueKey)(index, label),
      onClick: function onClick() {
        return clicked(value);
      },
      onKeyPress: function onKeyPress() {
        return clicked(value);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "checkbox-wrapper"
    }, label));
  }));
}

OptionList.propTypes = {
  name: _propTypes.default.string,
  options: _types.optionsList,
  clicked: _propTypes.default.func,
  selected: _propTypes.default.string
};
OptionList.defaultProps = {
  name: 'option',
  options: null,
  selected: null,
  clicked: function clicked() {}
};
var _default = OptionList;
exports.default = _default;